import React from 'react';
import {Stepper} from "./Stepper";
import css from "./Odometer.module.css"

const Odometer = ({number, className, style}) => {
    // Превращаем число в массив цифр и переворачиваем, 
    // чтобы индекс соответствовал разряду (0 - единицы, 1 - десятки и т.д.)
    const digits = `${Math.abs(number)}`.split("").reverse();
    const odometerClasses = [css.odometer, className];

    return (
        <div className={odometerClasses.join(" ")} style={style}>
            {number < 0 && <span>-</span>}
            {digits.map((value, index) => (
                <Stepper 
                    key={index} // Стабильный ключ для разряда
                    num={parseInt(value, 10)}
                />
            )).reverse() /* Возвращаем правильный порядок отображения */}
        </div>
    );
};

export {Odometer};
